import React from 'react';
import { renderToString } from 'react-dom/server';
import { useDispatch, useSelector } from 'react-redux';
import QRImage from 'react-qr-image';
import _ from 'underscore';

import { Manifest } from 'services/action';

import { Print } from 'ui/components';
import logoBlack from 'ui/assets/envio-black.png';
import { formatDate } from 'utilities/common';
import { currencyFormat } from 'utilities/common';

const POD_URL = `${process.env.REACT_APP_POD_SYSTEM_URL}`;

const PrintManifest = ({ match }) => {
  const Dispatch = useDispatch();
  const client = useSelector((state) => state?.Auth?.session?.client);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Manifest.Show']
  );

  const [data, setData] = React.useState(null);
  const [page, setPage] = React.useState(null);
  const [loaded, setLoaded] = React.useState(false);
  const [firstPage] = React.useState(8);
  const [limit] = React.useState(9);
  const [shipmentItem, setShipmentItem] = React.useState(null);

  const $onLoad = async (id) => {
    const detail = await Dispatch(Manifest.$show(id));
    if (detail?.message === 'success') {
      setData(detail?.data);
    }
  };

  React.useEffect(() => {
    setLoaded(false);
    $onLoad(match?.params?.id);
  }, []);

  React.useEffect(() => {
    if (data) {
      let pages = [];
      if (data?.legs) {
        pages = _.chunk(data?.legs, firstPage);
        if (data?.legs?.length > firstPage) {
          let first = pages[0];
          let last = _.rest(data?.legs, first?.length);
          pages = _.chunk(last, limit);
          pages.unshift(first);
        } else {
          setPage(pages);
        }
      } else {
        pages = _.chunk(data?.jobs, firstPage);
        if (data?.jobs?.length > firstPage) {
          let first = pages[0];
          let last = _.rest(data?.jobs, first?.length);
          pages = _.chunk(last, limit);
          pages.unshift(first);
        } else {
          setPage(pages);
        }
      }

      let tkol = 0;
      let tweight = 0;
      _.each(data?.jobs, function (i) {
        tkol += i?.delivery_order?.shipment?.total_quantity;
        tweight += i?.delivery_order?.shipment?.total_weight;
      });

      setShipmentItem({ total_quantity: tkol, total_weight: tweight });
      setPage(pages);
      setLoaded(true);
    }
  }, [data]);

  if (StateLoading || data === null || !loaded) return null;

  const TableLastMile = ({ pageData, id }) => {
    if (!(data?.type === 'last_mile' || data?.type === 'return')) return null;

    return (
      <table className="bordered">
        <thead>
          <tr className="bordered">
            <td className="bordered center" style={{ width: '3%' }}>
              <p className="bold mb-0">No.</p>
            </td>
            <td className="bordered left" style={{ width: '10%' }}>
              <p className="bold mb-0">Pickup/Drop</p>
            </td>
            <td className="bordered left" style={{ width: '30%' }}>
              <p className="bold mb-0">Lokasi</p>
            </td>
            <td className="bordered left" style={{ width: '12%' }}>
              <p className="bold mb-0">Shipment</p>
            </td>
            <td className="bordered center" style={{ width: '20%' }}>
              <p className="bold mb-0">Shipment Detail</p>
            </td>
            <td className="bordered center" style={{ width: '20%' }}>
              <p className="bold mb-0">Catatan</p>
            </td>
          </tr>
        </thead>

        <tbody>
          {pageData?.map((d, i) => {
            let newData = [];
            let comodity = [];
            _.map(d?.jobs, function (job) {
              _.each(job?.delivery_order?.shipment?.items, function (item) {
                comodity.push(item);
              });
            });

            if (comodity?.length > 0) {
              let x = _.uniq(comodity, 'item_name');
              _.each(x, function (u) {
                let uniqs = _.where(comodity, { item_name: u?.item_name });

                let weight = _.reduce(
                  uniqs,
                  function (memo, num) {
                    return (
                      memo + (num?.m3 > num?.weight ? num?.m3 : num?.weight)
                    );
                  },
                  0
                );

                let qty = _.reduce(
                  uniqs,
                  function (memo, num) {
                    return memo + num?.quantity;
                  },
                  0
                );

                let newObj = {
                  item_name: u?.item_name,
                  total_weight: weight,
                  total_quantity: qty,
                };
                newData?.push(newObj);
              });
            }

            return (
              <tr key={i} className="bordered">
                <td className="bordered center">
                  <p className=" mb-0">
                    {id > 1
                      ? limit + (firstPage * (id - 1) + i + 1)
                      : firstPage * id + i + 1}
                  </p>
                </td>
                <td className="bordered left">
                  <p className="mb-0 text-capitalize">
                    {d?.type?.replace('_', ' ')}
                  </p>
                </td>
                <td className="bordered left">
                  <div className="table-col">
                    <p className="fs-8 mb-0 fw-semibold">
                      {d?.location?.name} - {d?.location?.phone_number}
                    </p>
                    <small className="info mb-0">{d?.location?.address}</small>
                    <small className="info mb-0">
                      {d?.location?.region?.district_name},{' '}
                      {d?.location?.region?.regency_name},{' '}
                      {d?.location?.region?.province_name}
                    </small>
                  </div>
                </td>
                <td className="bordered left">
                  <div className="table-col">
                    {d?.jobs?.map((jo, i) => (
                      <p key={i} className="mb-0">
                        {i + 1}. {jo?.delivery_order?.shipment?.code || '-'}
                        {jo?.delivery_order?.shipment?.ref_code}
                      </p>
                    ))}
                  </div>
                </td>
                <td className="bordered ">
                  <div className="table-col">
                    <p className="mb-0">
                      <b>Komoditas: </b>
                    </p>
                    {newData?.map((item, i) => (
                      <p key={i} className="mb-0">
                        {i + 1}. {item?.item_name || '-'} :{' '}
                        {currencyFormat(item?.total_weight || 0)} Kg (
                        {currencyFormat(item?.total_quantity || 0)} Koli)
                      </p>
                    ))}
                    <p>
                      <b>Total Berat: </b>
                      {currencyFormat(
                        _.reduce(
                          d?.jobs,
                          function (job, i) {
                            let x = _.reduce(
                              i?.delivery_order?.shipment?.items,
                              function (s, o) {
                                return s + o?.weight;
                              },
                              0
                            );
                            return job + x;
                          },
                          0
                        )
                      ) +
                        ' Kg ' +
                        '(' +
                        currencyFormat(
                          _.reduce(
                            d?.jobs,
                            function (job, i) {
                              let x = _.reduce(
                                i?.delivery_order?.shipment?.items,
                                function (s, o) {
                                  return s + o?.quantity;
                                },
                                0
                              );
                              return job + x;
                            },
                            0
                          )
                        ) +
                        ' Koli)'}
                    </p>
                    {d?.type === 'drop_point' &&
                      data?.moda_type === 'land_freight' && (
                        <p>
                          <b>COD: </b>
                          {currencyFormat(
                            _.reduce(
                              d?.jobs,
                              function (job, i) {
                                return (
                                  job + i?.delivery_order?.shipment?.cod_value
                                );
                              },
                              0
                            )
                          )}
                        </p>
                      )}
                  </div>
                </td>
                <td className="bordered left">
                  <p className=" mb-0">
                    {(d?.jobs?.length > 0 &&
                      d?.jobs[0]?.delivery_order?.shipment?.instruction) ||
                      '-'}
                  </p>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  const TableFirstConsole = ({ pageData, id }) => {
    if (!(data?.type === 'console' || data?.type === 'pickup')) return null;

    return (
      <table className="bordered">
        <thead>
          <tr className="bordered">
            <td className="bordered center" style={{ width: '3%' }}>
              <p className="bold mb-0">No.</p>
            </td>
            <td className="bordered left" style={{ width: '10%' }}>
              <p className="bold mb-0">Pickup/Drop</p>
            </td>
            <td className="bordered left" style={{ width: '30%' }}>
              <p className="bold mb-0">Lokasi</p>
            </td>
            <td className="bordered left" style={{ width: '12%' }}>
              <p className="bold mb-0">Shipment</p>
            </td>
            <td className="bordered center" style={{ width: '20%' }}>
              <p className="bold mb-0">Shipment Detail</p>
            </td>
            <td className="bordered center" style={{ width: '20%' }}>
              <p className="bold mb-0">Catatan</p>
            </td>
          </tr>
        </thead>

        <tbody>
          {pageData?.map((d, i) => {
            let newData = [];
            let comodity = [];
            _.map(d?.jobs, function (job) {
              _.each(job?.delivery_order?.shipment?.items, function (item) {
                comodity.push(item);
              });
            });

            if (comodity?.length > 0) {
              let x = _.uniq(comodity, 'item_name');
              _.each(x, function (u) {
                let uniqs = _.where(comodity, { item_name: u?.item_name });

                let weight = _.reduce(
                  uniqs,
                  function (memo, num) {
                    return (
                      memo + (num?.m3 > num?.weight ? num?.m3 : num?.weight)
                    );
                  },
                  0
                );

                let qty = _.reduce(
                  uniqs,
                  function (memo, num) {
                    return memo + num?.quantity;
                  },
                  0
                );

                let newObj = {
                  item_name: u?.item_name,
                  total_weight: weight,
                  total_quantity: qty,
                };
                newData?.push(newObj);
              });
            }

            return (
              <tr key={i} className="bordered">
                <td className="bordered center">
                  <p className=" mb-0">
                    {id > 1
                      ? limit + (firstPage * (id - 1) + i + 1)
                      : firstPage * id + i + 1}
                  </p>
                </td>
                <td className="bordered left">
                  <p className="mb-0 text-capitalize">
                    {d?.type?.replace('_', ' ')}
                  </p>
                </td>
                <td className="bordered left">
                  <div className="table-col">
                    <p className="fs-8 mb-0 fw-semibold">
                      {d?.location?.name} - {d?.location?.phone_number}
                    </p>
                    <small className="info mb-0">{d?.location?.address}</small>
                    <small className="info mb-0">
                      {d?.location?.region?.district_name},{' '}
                      {d?.location?.region?.regency_name},{' '}
                      {d?.location?.region?.province_name}
                    </small>
                  </div>
                </td>
                <td className="bordered left">
                  <div className="table-col">
                    {d?.jobs?.map((jo, i) => (
                      <p key={i} className="mb-0">
                        {i + 1}. {jo?.delivery_order?.shipment?.code || '-'}
                        {jo?.delivery_order?.shipment?.ref_code}
                      </p>
                    ))}
                  </div>
                </td>
                <td className="bordered ">
                  <div className="table-col">
                    <p className="mb-0">
                      <b>Komoditas: </b>
                    </p>
                    {newData?.map((item, i) => (
                      <p key={i} className="mb-0">
                        {i + 1}. {item?.item_name || '-'} :{' '}
                        {currencyFormat(item?.total_weight || 0)} Kg (
                        {currencyFormat(item?.total_quantity || 0)} Koli)
                      </p>
                    ))}
                    <p>
                      <b>Total Berat: </b>
                      {currencyFormat(
                        _.reduce(
                          d?.jobs,
                          function (job, i) {
                            let x = _.reduce(
                              i?.delivery_order?.shipment?.items,
                              function (s, o) {
                                return s + o?.weight;
                              },
                              0
                            );
                            return job + x;
                          },
                          0
                        )
                      ) +
                        ' Kg ' +
                        '(' +
                        currencyFormat(
                          _.reduce(
                            d?.jobs,
                            function (job, i) {
                              let x = _.reduce(
                                i?.delivery_order?.shipment?.items,
                                function (s, o) {
                                  return s + o?.quantity;
                                },
                                0
                              );
                              return job + x;
                            },
                            0
                          )
                        ) +
                        ' Koli)'}
                    </p>
                  </div>
                </td>
                <td className="bordered left">
                  <p className=" mb-0">
                    {(d?.jobs?.length > 0 &&
                      d?.jobs[0]?.delivery_order?.shipment?.instruction) ||
                      '-'}
                  </p>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  const TableForwarder = ({ pageData, id }) => {
    if (!(data?.type === 'forwarder')) return null;

    return (
      <table className="bordered">
        <thead>
          <tr className="bordered">
            <td className="bordered center" style={{ width: '3%' }}>
              <p className="bold mb-0">No.</p>
            </td>
            <td className="bordered left" style={{ width: '10%' }}>
              <p className="bold mb-0">Shipment</p>
            </td>
            <td className="bordered left" style={{ width: '10%' }}>
              <p className="bold mb-0">Pickup/Drop</p>
            </td>
            <td className="bordered left" style={{ width: '30%' }}>
              <p className="bold mb-0">Lokasi</p>
            </td>
            <td className="bordered center" style={{ width: '20%' }}>
              <p className="bold mb-0">Shipment Detail</p>
            </td>
          </tr>
        </thead>

        <tbody>
          {pageData?.map((d, i) => {
            let newData = [];
            let comodity = [];
            _.each(d?.delivery_order?.shipment?.items, function (item) {
              comodity.push(item);
            });

            if (comodity?.length > 0) {
              let x = _.uniq(comodity, 'item_name');
              _.each(x, function (u) {
                let uniqs = _.where(comodity, { item_name: u?.item_name });

                let weight = _.reduce(
                  uniqs,
                  function (memo, num) {
                    return (
                      memo + (num?.m3 > num?.weight ? num?.m3 : num?.weight)
                    );
                  },
                  0
                );

                let qty = _.reduce(
                  uniqs,
                  function (memo, num) {
                    return memo + num?.quantity;
                  },
                  0
                );

                let newObj = {
                  item_name: u?.item_name,
                  total_weight: weight,
                  total_quantity: qty,
                };
                newData?.push(newObj);
              });
            }

            return (
              <tr key={i} className="bordered">
                <td className="bordered center">
                  <p className=" mb-0">
                    {id > 1
                      ? limit + (firstPage * (id - 1) + i + 1)
                      : firstPage * id + i + 1}
                  </p>
                </td>
                <td className="bordered left">
                  <p className="mb-0 text-capitalize">
                    {d?.delivery_order?.shipment?.code}
                  </p>
                </td>
                <td className="bordered left">
                  <div className="table-col">
                    <p className="fs-8 mb-0 fw-semibold">
                      {d?.origin?.name} - {d?.destination?.name}
                    </p>
                  </div>
                </td>
                <td className="bordered left">
                  <div className="table-col">
                    <small className="info mb-0">
                      {d?.destination?.address}
                    </small>
                    <small className="info mb-0">
                      {d?.destination?.region?.district_name},{' '}
                      {d?.destination?.region?.regency_name},{' '}
                      {d?.destination?.region?.province_name}
                    </small>
                  </div>
                </td>
                <td className="bordered ">
                  <div className="table-col">
                    <p className="mb-0">
                      <b>Komoditas: </b>
                    </p>
                    {newData?.map((item, i) => (
                      <p key={i} className="mb-0">
                        {i + 1}. {item?.item_name || '-'} :{' '}
                        {currencyFormat(item?.total_weight || 0)} Kg (
                        {currencyFormat(item?.total_quantity || 0)} Koli)
                      </p>
                    ))}
                    {d?.delivery_order?.shipment?.cod_value > 0 && (
                      <p>
                        <b>COD: </b>
                        {currencyFormat(d?.delivery_order?.shipment?.cod_value)}
                      </p>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  return (
    <div>
      {!data || data === null ? null : (
        <Print
          title={`Manifest - ${data?.code}`}
          size="A4"
          content={renderToString(
            page?.map((p, id) => (
              <section
                className="sheet page-break"
                style={{ padding: '20px' }}
                key={id}
              >
                {id === 0 ? (
                  <>
                    <div
                      className="d-flex flex-row justify-content-between"
                      style={{ height: 132 }}
                    >
                      <div className="" style={{ width: '85%' }}>
                        <div
                          className="d-flex align-items-center border-bottom"
                          style={{
                            paddingTop: 10,
                            paddingBottom: 10,
                          }}
                        >
                          <div style={{ alignSelf: 'initial', width: '30%' }}>
                            <img
                              src={
                                client?.avatar?.replace('_thumb', '') ||
                                logoBlack
                              }
                              alt=""
                              style={{ maxHeight: 50, maxWidth: '100%' }}
                            />
                          </div>
                          <div style={{ paddingLeft: 20 }}>
                            <h2 className="bold uppercase">
                              Manifest {data?.type?.replace('_', ' ')}
                            </h2>
                            <p className="mb-0">
                              Tanggal Manifest :{' '}
                              {formatDate(data?.schedule_at, 'DD-MM-YYYY')}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div style={{ width: '15%' }}>
                        <div className="d-flex flex-column justify-content-center text-center align-items-center">
                          <QRImage
                            text={`${POD_URL}/manifest/${data?.id}`}
                            color="#000"
                            background="#fff"
                            style={{ height: 120 }}
                          />
                          <p className="mb-0" style={{ fontSize: 9 }}>
                            {data?.code}
                          </p>
                        </div>
                      </div>
                    </div>

                    {data?.type !== 'forwarder' && (
                      <table className="body" style={{ marginTop: -50 }}>
                        <tr style={{ verticalAlign: 'top' }}>
                          <td style={{ width: '50%', paddingTop: '10px' }}>
                            <h5 className="bold uppercase">
                              Informasi Armada :
                            </h5>
                            <table style={{ marginBottom: '15px' }}>
                              <tr style={{ textAlign: 'left' }}>
                                <td style={{ width: '25%', textAlign: 'left' }}>
                                  <p className="mb-0">Tipe</p>
                                </td>
                                <td>
                                  <p className="mb-0">:</p>
                                </td>
                                <td style={{ width: '70%', textAlign: 'left' }}>
                                  <p className="bold uppercase mb-0">
                                    {data?.moda_type?.replace('_', ' ')}
                                  </p>
                                </td>
                              </tr>
                              {data?.moda_type === 'land_freight' &&
                                data?.moda?.land_freight && (
                                  <>
                                    <tr style={{ textAlign: 'left' }}>
                                      <td>
                                        <p className="mb-0">Driver</p>
                                      </td>
                                      <td>
                                        <p className="mb-0">:</p>
                                      </td>
                                      <td>
                                        <p className="bold uppercase mb-0">
                                          {
                                            data?.moda?.land_freight?.driver
                                              ?.name
                                          }
                                        </p>
                                      </td>
                                    </tr>
                                    <tr style={{ textAlign: 'left' }}>
                                      <td>
                                        <p className="mb-0">Kendaraan</p>
                                      </td>
                                      <td>
                                        <p className="mb-0">:</p>
                                      </td>
                                      <td>
                                        <p className="bold uppercase mb-0">
                                          {data?.moda?.land_freight?.vehicle ? (
                                            `${data?.moda?.land_freight?.vehicle?.code}`
                                          ): (
                                            `${data?.moda?.land_freight?.vehicle_type?.name} ${' '}${'-'}${' '}
                                            ${data?.moda?.land_freight?.vehicle_number}`
                                          )}
                                        </p>
                                      </td>
                                    </tr>
                                  </>
                                )}

                              {data?.moda_type === 'sea_freight' &&
                                data?.moda?.sea_freight && (
                                  <>
                                    <tr style={{ textAlign: 'left' }}>
                                      <td>
                                        <p className="mb-0">BL Code</p>
                                      </td>
                                      <td>
                                        <p className="mb-0">:</p>
                                      </td>
                                      <td>
                                        <p className="bold uppercase mb-0">
                                          {data?.moda?.sea_freight?.bl_code}
                                        </p>
                                      </td>
                                    </tr>
                                    <tr style={{ textAlign: 'left' }}>
                                      <td>
                                        <p className="mb-0">No. Container</p>
                                      </td>
                                      <td>
                                        <p className="mb-0">:</p>
                                      </td>
                                      <td>
                                        <p className="bold uppercase mb-0">
                                          {
                                            data?.moda?.sea_freight
                                              ?.no_container
                                          }
                                        </p>
                                      </td>
                                    </tr>
                                    <tr style={{ textAlign: 'left' }}>
                                      <td>
                                        <p className="mb-0">No. Vessel</p>
                                      </td>
                                      <td>
                                        <p className="mb-0">:</p>
                                      </td>
                                      <td>
                                        <p className="bold uppercase mb-0">
                                          {data?.moda?.sea_freight?.no_vessel}
                                        </p>
                                      </td>
                                    </tr>
                                  </>
                                )}

                              {data?.moda_type === 'air_freight' &&
                                data?.moda?.air_freight && (
                                  <>
                                    <tr style={{ textAlign: 'left' }}>
                                      <td>
                                        <p className="mb-0">Airplane</p>
                                      </td>
                                      <td>
                                        <p className="mb-0">:</p>
                                      </td>
                                      <td>
                                        <p className="bold uppercase mb-0">
                                          {data?.moda?.air_freight?.airplane}
                                        </p>
                                      </td>
                                    </tr>
                                    <tr style={{ textAlign: 'left' }}>
                                      <td>
                                        <p className="mb-0">Code SMU</p>
                                      </td>
                                      <td>
                                        <p className="mb-0">:</p>
                                      </td>
                                      <td>
                                        <p className="bold uppercase mb-0">
                                          {data?.moda?.air_freight?.code_smu}
                                        </p>
                                      </td>
                                    </tr>
                                    <tr style={{ textAlign: 'left' }}>
                                      <td>
                                        <p className="mb-0">No. Manifest</p>
                                      </td>
                                      <td>
                                        <p className="mb-0">:</p>
                                      </td>
                                      <td>
                                        <p className="bold uppercase mb-0">
                                          {data?.moda?.air_freight?.no_manifest}
                                        </p>
                                      </td>
                                    </tr>
                                    <tr style={{ textAlign: 'left' }}>
                                      <td>
                                        <p className="mb-0">Total Berat</p>
                                      </td>
                                      <td>
                                        <p className="mb-0">:</p>
                                      </td>
                                      <td>
                                        <p className="bold uppercase mb-0">
                                          {`${shipmentItem?.total_weight} (KG) \n ${shipmentItem?.total_quantity} (Koli)`}
                                        </p>
                                      </td>
                                    </tr>
                                    <tr style={{ textAlign: 'left' }}>
                                      <td>
                                        <p className="mb-0">Flight Time</p>
                                      </td>
                                      <td>
                                        <p className="mb-0">:</p>
                                      </td>
                                      <td>
                                        <p className="bold uppercase mb-0">
                                          {formatDate(
                                            data?.moda?.air_freight?.date
                                          )}{' '}
                                          -{' '}
                                          {formatDate(
                                            data?.moda?.air_freight?.etd
                                          )}
                                        </p>
                                      </td>
                                    </tr>
                                  </>
                                )}
                            </table>
                          </td>
                        </tr>
                      </table>
                    )}
                  </>
                ) : null}

                <div style={{ marginTop: 20 }}>
                  <TableLastMile pageData={p} id={id} />
                  <TableFirstConsole pageData={p} id={id} />
                  <TableForwarder pageData={p} id={id} />
                </div>
              </section>
            ))
          )}
        />
      )}
    </div>
  );
};

export default PrintManifest;
